
import { useState } from "react"
import PropTypes from 'prop-types'
import { Modal, Button, Typography } from "antd"
import { ExclamationCircleOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import { toaster } from "components/common/Toast"

const { Text } = Typography

const DeleteCardModal = ({ open, onCancel, onConfirm, cardLast4}) => {
  const { t } = useTranslation()
  const [deleting, setDeleting] = useState(false)
  const handleConfirm = async () => {
    setDeleting(true)
    try {
      await onConfirm()
    } catch (error) {
      toaster.error(error?.message)
    } finally {
      setDeleting(false)
    }
  }

  return (
    <Modal open={open} onCancel={onCancel} footer={null} centered closable width={400} bodyStyle={{ textAlign: "center", padding: "24px" }}>
      <div className="flex justify-center mb-4">
        <ExclamationCircleOutlined style={{ fontSize: 40, color: "#faad14" }} />
      </div>

      <Text strong style={{ fontSize: 18, display: "block", marginBottom: 8 }}>
        {t("payment.delete_card_title")}
      </Text>

      <Text type="secondary" style={{ display: "block", marginBottom: 24 }}>
        {t("payment.delete_card_message", { last4: cardLast4 })}
      </Text>
      <div className="flex justify-center gap-3">
        <Button onClick={onCancel} shape="round">
          {t("common.cancel")}
        </Button>
        <Button danger type="primary" onClick={handleConfirm} shape="round" loading={deleting}>
          {t("payment.delete")}
        </Button>
      </div>
    </Modal>
  )
}

DeleteCardModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  cardLast4: PropTypes.string.isRequired
}

export default DeleteCardModal
